export const fileUploader = {
  title: 'Upload files',
  deleteAll: 'Delete all files',
  notAllowedFileType: 'Sorry, you cannot add this extension(s):',
  closeAlert: {
    title: 'Warning!',
    header: 'All uploaded files will be lost.',
    content: 'Are you sure you want to close?',
    accept: 'Yes',
    reject: 'No',
  },
  submitAlert: {
    header: 'Some files are still uploading',
    content: 'You cannot submit files until uploading is finished',
    accept: 'OK',
  },
  fileTypeAlert: {
    header: 'Invalid file type(s)',
    content: 'You cannot submit files with the extension(s):',
    accept: 'OK',
  },
  tooBigFilesAlert: {
    header: 'Files are too big',
    content: 'You cannot upload files bigger than 10GB',
    accept: 'OK',
  },
  openUploader: {
    drop: 'Drop files or',
    clickHere: 'click here',
    upload: 'to upload',
  },
  errorFallback: {
    title: 'Something went wrong',
    tryAgain: 'Try again',
  },
};
